import {getEnglishPlurals} from '@ThemesApp/common/utils/pluralize';

export default {
  score: {
    heading: 'Rate the article',
    message: 'Vote cast',
    votes: votes => `${getEnglishPlurals(["opinion", "opinions"], +votes)},`,
    score: 'rating'
  },
  feedback: {
    label: 'Is this article helpful?'
  }
};
